import type React from 'react'
import { cn } from '@/frontend/utils'

export const H4 = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <h4 className={cn('font-semibold text-base lg:text-lg', className)}>{children}</h4>
}
